(ns common.schema.entities.person.core
  (:require [common.roles :as roles]
            [common.schema.entities.person :as person]))

;; Verbatim copy of common.schema.entity-types's shared crm-delete-check-fn,
;; which person's existing entry references directly - required here, not
;; there, to avoid a circular namespace dependency (entity_types.cljc
;; requires this registry). Keep in sync if the original ever changes.
(defn- disable-permissions-check-fn
  [{:keys [tr role]}]
  (when-not (roles/user? role)
    (tr :not-allowed)))

(def entity-type-definition
  {:entity-type                  :entity.type/person
   :schema                       person/schema
   :name                         {:en "Contact"}
   :plural                       {:en "Contacts"}
   :icon                         :fa-user
   :create-icon                  :fa-user-plus
   :read-permissions-check-fn    (fn [{:keys []}] true)
   :disable-permissions-check-fn disable-permissions-check-fn

   ;; Explicitly false: person's dedicated OpenSearch index already exists
   ;; and is populated via the legacy common.opensearch.entity-indices
   ;; mechanism, not the newer :entity/search-index?-driven
   ;; backend.search.dedicated.indexes/init! path - this key would otherwise
   ;; default to true just because :search is present below.
   :search-index?                false

   :search                       {:result/title-attr    :person/name
                                  :list/default-columns [:person/name
                                                         :person/last-name
                                                         :person/universal-email-address
                                                         :person/universal-phone-number
                                                         :person/tag-tags
                                                         :person/notes
                                                         :person/contact-owner]
                                  :views                {:grid {:po-default-field-paths [[:person/name]
                                                                                         [:person/last-name]
                                                                                         [:person/universal-email-address]
                                                                                         [:person/universal-phone-number]
                                                                                         [:person/tag-tags]
                                                                                         [:person/notes]
                                                                                         [:person/contact-owner]]
                                                                :mandatory-field-paths  [[:person/universal-email-address]]}}}})
